module.exports = __webpack_public_path__ + "img/user05.1b4eeb7c.png";